<template>
    <div class="h-full relative p-6 lg:p-12">
        <div
            class="absolute inset-0 z-20 bg-gray-500 bg-opacity-90 transition-opacity"
            v-if="!stepComplete && step1Errors.length === 0"
        ></div>
        <div
            class="absolute inset-0 z-20"
            v-if="!stepComplete && step1Errors.length === 0"
        >
            <div class="absolute inset-0 z-20 w-100 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
                >
                    <div
                        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
                    >
                        <div>
                            <div
                                class="mx-auto flex items-center justify-center"
                            >
                                <span class="fa-stack relative z-20 fa-lg">
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-red-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                                    ></i>
                                </span>
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3
                                    class="text-base font-semibold leading-6 text-gray-900"
                                    id="modal-title"
                                >
                                    Go Back to the Previous Step
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">
                                        You must complete the previous step
                                        before continuing.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!stepComplete && step1Errors.length > 0">
            <div class="rounded-lg bg-white p-6 shadow-lg mb-12">
                <h3
                    class="text-lg xl:text-xl font-semibold leading-6 mb-3"
                    v-if="step1Errors.length === 0 || step1.too_early"
                >
                    Step 2: We’re Still Awaiting a New Southwest Credit Card to
                    Appear in Your My10x Wallet.
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-orange-100"
                        ></i>
                        <i
                            class="fa-regular fa-timer fa-stack-1x fa-inverse text-orange-700"
                        ></i>
                    </span>
                </h3>
                <h3
                    class="text-lg xl:text-xl font-semibold leading-6 mb-3"
                    v-if="step1Errors.length > 0 && !step1.too_early"
                >
                    Step 2: You've added your card, but we need a little bit
                    more info.
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-red-100"
                        ></i>
                        <i
                            class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                        ></i>
                    </span>
                </h3>
                <div v-if="step1Errors.length === 0">
                    <p class="mb-3">
                        Have you been approved for a new Southwest Credit Card?
                    </p>
                    <a
                        href="/wallet#add-account"
                        class="btn btn-orange !ml-0 !text-md mb-6"
                        target="_blank"
                    >
                        Add It To Your My10x Wallet
                        <i class="fa-light fa-arrow-right ml-2"></i>
                    </a>
                    <p class="text-xs">
                        <em>
                            (If your My10x wallet is connected to your Chase
                            account, we'll automatically import your new card
                            within 24 hours of it showing up in your Chase
                            account, so you don't need to do anything.)
                        </em>
                    </p>
                </div>

                <OpenCard
                    :card="step1?.cards[0]"
                    :account="step1?.accounts[0]"
                />
            </div>
        </div>
        <div v-if="stepComplete">
            <div class="rounded-lg bg-white p-6 shadow-lg mb-12">
                <h3 class="text-lg xl:text-xl font-semibold leading-6 mb-3">
                    Step 2 Complete
                    <span class="fa-stack">
                        <i
                            class="fa-solid fa-circle fa-stack-2x text-green-100"
                        ></i>
                        <i
                            class="fa-regular fa-check fa-stack-1x fa-inverse text-green-700"
                        ></i>
                    </span>
                </h3>
                <p class="text-base mb-3">
                    You've taken the second step in earning your Companion Pass
                    by adding your
                    <span class="font-semibold">
                        {{ step?.cards[0].title }}
                    </span>
                    to your My10x Wallet.
                </p>

                <p class="text-base">
                    <span class="font-semibold">Date Added:</span>
                    {{ step?.added_on }}
                </p>
            </div>
            <OpenCard :card="step?.cards[0]" :account="step?.accounts[0]" />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

import OpenCard from '@/components/companion-pass/cards/open-card.vue';

export default {
    name: 'StepTwo',
    props: {},
    components: {
        OpenCard,
    },
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, ['completeSteps']),
        step1() {
            return this.getStep(1);
        },
        stepContent() {
            return this.getStepContent(2);
        },
        step() {
            return this.getStep(2);
        },
        step1Errors() {
            return this.step1?.card_errors || [];
        },
        stepComplete() {
            return 2 in this.completeSteps ? true : false;
        },
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, ['getStep', 'getStepContent']),
    },
    mounted() {},
};
</script>
